import { render, staticRenderFns } from "./FiltersTop.vue?vue&type=template&id=bf97f360&scoped=true&"
import script from "./FiltersTop.vue?vue&type=script&lang=js&"
export * from "./FiltersTop.vue?vue&type=script&lang=js&"
import style0 from "./FiltersTop.vue?vue&type=style&index=0&id=bf97f360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf97f360",
  null
  
)

export default component.exports